import { getRequestNew } from "../../lib/fetchClient";
import { baseUrl } from "../../lib/util";

export const getPaginatedCategoryCourses = async ({
  categorySlug,
  lang = "en",
  page = 1,
  pageSize = 8,
  isPCategory = false,
}) => {
  const categoryCollection = isPCategory
    ? "p-category-types"
    : "category-types";
  const url =
    `${baseUrl}/api/${categoryCollection}/${encodeURIComponent(categorySlug)}/courses` +
    `?page=${page}&pageSize=${pageSize}`;

  return getRequestNew(url, { lang }, false);
};
